<ft-initialized-content [isInitialized]="isInitialized">
    <ft-sections #ftSecsTop [registry]="[{name: 'prestay', isActive: true}, {name: 'poststay', isActive: false}, {name: 'photocontest', isActive: false}, {name: 'inspiration1', isActive: false}, {name: 'inspiration2', isActive: false}, {name: 'superchargers1', isActive: false}, {name: 'superchargers2', isActive: false}, {name: 'superchargers3', isActive: false}]"
                 (afterInit)="onSectionsInitialized($event.controller)">
        <ft-carousel-cards [options]="{paddingElement: 'li'}"
                           (afterInit)="onCarouselCardsInitialized($event.controller)">
            <section class="ft-master-section ft-journeys-master">
                <nav class="ft-nav ft-journeys-nav">
                    <ul>
                        <li class="ft-journey-group-item first ft-persona-scheme-guests" ft-carousel-card="prestay" active [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('prestay') || '')"
                            ft-carousel-card-move-left-or-right>
                            <div class="ft-journey-group-label">
                                <span>For guests</span>
                            </div>
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Pre-stay</h2>
                                        <p class="ft-summary">
                                            Your guest just booked a room&mdash;now is the perfect moment to start Advocacy. Follow the entire journey below, but first…
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Meet Jill</div>
                                    <div class="ft-persona-summary">She'll represent your guest.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item ft-persona-scheme-guests" ft-carousel-card="poststay" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('poststay') || '')"
                            ft-carousel-card-move-left-or-right
                            (click)="fetchPoststaySection();">
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Post-stay</h2>
                                        <p class="ft-summary">
                                            After your guest returns home from their trip, it's time to find out what they have to say (and show!) about their experience.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Jill's back home</div>
                                    <div class="ft-persona-summary">And she has great memories to share.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item last ft-persona-scheme-guests" ft-carousel-card="photocontest" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('photocontest') || '')"
                            ft-carousel-card-move-left-or-right
                            (click)="fetchPhotoContestSection();">
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Storytellers</h2>
                                        <p class="ft-summary">
                                            Approve your guest's story for the campaign and watch as friends &amp; family come to show their love.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Jill is a storyteller</div>
                                    <div class="ft-persona-summary">Game on!</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item first ft-persona-scheme-friends" ft-carousel-card="inspiration1" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('inspiration1') || '')"
                            ft-carousel-card-move-left-or-right>
                            <div class="ft-journey-group-label">
                                <span>For friends</span>
                            </div>
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Build awareness</h2>
                                        <p class="ft-subheading ft-text-plus-2">through trusted introductions</p>
                                        <p class="ft-summary">
                                            Make a lasting impression when your guest shares about her stay and introduces your
                                            hotel to friends &amp; family.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Meet Jack</div>
                                    <div class="ft-persona-summary">He's a friend of your guest.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item last ft-persona-scheme-friends" ft-carousel-card="inspiration2" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('inspiration2') || '')"
                            ft-carousel-card-move-left-or-right>
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Inspiration</h2>
                                        <p class="ft-subheading ft-text-plus-2">through Storytellers</p>
                                        <p class="ft-summary">
                                            Friends & family come to show their support and experience your guest's favorite
                                            moment from her stay.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Jack brings his vote</div>
                                    <div class="ft-persona-summary">And leaves with a bonus.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item first ft-persona-scheme-visitors" ft-carousel-card="superchargers1" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('superchargers1') || '')"
                            ft-carousel-card-move-left-or-right>
                            <div class="ft-journey-group-label">
                                <span>For website visitors</span>
                            </div>
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Story River</h2>
                                        <p class="ft-summary">
                                            Show your website visitors authentic guest stories that resonate with their travel
                                            aspirations.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Meet X3Mqq7</div>
                                    <div class="ft-persona-summary">That's an anonymous site visitor.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-anonymous-1"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item ft-persona-scheme-visitors" ft-carousel-card="superchargers2" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('superchargers2') || '')"
                            ft-carousel-card-move-left-or-right
                            (click)="fetchHomepageSection();">
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Unlock future advocates</h2>
                                        <p class="ft-summary">
                                            Give visitors who are not ready to 'Book Now' an easy way back for when they've decided,
                                            plus get them primed for advocacy.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Meet Y4NtpU</div>
                                    <div class="ft-persona-summary">That's an anonymous site visitor.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-anonymous-2"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="ft-journey-group-item last ft-persona-scheme-visitors" ft-carousel-card="superchargers3" [ftSectionTrigger]="(carouselCardsController?.getMoveLeftOrRightCardName?.('superchargers3') || '')"
                            ft-carousel-card-move-left-or-right
                            (click)="fetchQuoteListSection();">
                            <div class="ft-journey-card">
                                <div class="ft-container ft-v-align-container">
                                    <div class="ft-content ft-v-align-content">
                                        <h2 class="ft-heading ft-text-plus-6">Traveler quotes</h2>
                                        <p class="ft-summary">
                                            Show visitors genuine testimonials revealing the best experiences that recent guests
                                            had at your hotel.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-journey-persona">
                                    <div class="ft-persona-name">Meet Z5Oiw9</div>
                                    <div class="ft-persona-summary">That's an anonymous site visitor.</div>
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-anonymous-3"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="ft-journey-cards-nav">
                        <a ft-carousel-cards-move-left [ftSectionTrigger]="(carouselCardsController?.moveLeftCardName || '')" (click)="fetchSectionData(carouselCardsController?.moveLeftCardName)">
                            <span class="ft-icn-caret-left"></span>
                        </a>
                        <a ft-carousel-cards-move-right [ftSectionTrigger]="(carouselCardsController?.moveRightCardName || '')" (click)="fetchSectionData(carouselCardsController?.moveRightCardName)">
                            <span class="ft-icn-caret-right"></span>
                        </a>
                    </div>
                </nav>
                <div class="ft-journey">
                    <!-- PRE-STAY ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="prestay" class="ft-persona-scheme-guests" [ngClass]="{'is-journey-off': !platformActivationStatus.prestay, 'is-journey-inactive': (!!prestayAdvocacy && !prestayAdvocacy?.isActive)}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.prestay || (!!prestayAdvocacy && !prestayAdvocacy?.isActive)">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert" *ngIf="!platformActivationStatus.prestay">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is OFF.</h3>
                                            <p>
                                                Explore the journey below to learn about what your guests will see.
                                                <br /> Contact your account manager to launch this feature.
                                            </p>
                                            <ft-switch *ngIf="isFliptoStaff" state="platformActivationStatus.prestay" on-change="toggleLayer('prestay')" />
                                        </div>
                                    </div>
                                    <div class="ft-alert" *ngIf="platformActivationStatus.prestay && !!prestayAdvocacy && !prestayAdvocacy?.isActive">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Your guests will not see this journey until you activate your Confirmation Experience touchpoint below.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-confirmationexperience"
                                                 [ngClass]="{'is-option-integrated': prestayAdvocacy?.confirmationDisplayTypeId != 3}">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual page will display your photos and appointed
                                                        representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-confirmationexperience-info">
                                                <p>
                                                    After Jill finalizes her reservation we want to affirm that she made the right decision to book at your hotel and generate
                                                    more excitement. We do this right on your confirmation page.
                                                </p>
                                                <p>
                                                    Prefaced with a friendly greeting from your team, your confirmation experience transforms into a powerful new conversion
                                                    point.
                                                </p>
                                                <p>
                                                    You'll present a small gift to share with friends &amp; family, as well as a special treat for her upcoming stay.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !prestayAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{prestayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'confirmation'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Confirmation Experience</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-guest"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">Jill's a new advocate!</h2>
                                    <p class="ft-summary">
                                        When Jill shares to her friends, she'll grow from an upcoming guest to a budding advocate. This is an important moment&mdash;we
                                        now have a better sense that Jill is willing to have more interactions with your
                                        brand and we can start nurturing this relationship.
                                    </p>

                                    <div class="ft-conversion-display" *ngIf="!!prestayShareIncentive" ft-state-class="{'active': 'guest-journeys.prestay'}" inverse>
                                        <div class="ft-participant-incentive">
                                            <div class="ft-supertitle-divider">
                                                <div class="ft-supertitle">
                                                    <i class="ft-icn-sun"></i>Thank Jill for sharing
                                                </div>
                                            </div>
                                            <div class="ft-incentive-name ft-text-plus-2" [innerHTML]="prestayShareIncentive.name"></div>
                                        </div>
                                        <a class="ft-link-underline ft-text-minus-1" *ngIf="!!prestayShareIncentive" ft-set-state="guest-journeys.prestay">View all variations for this conversion point</a>
                                    </div>
                                    <div class="ft-conversion-display" *ngIf="!prestayShareIncentive" ft-state-class="{'active': 'guest-journeys.prestay'}" inverse>
                                        <a class="ft-link-underline ft-text-minus-1" ft-set-state="guest-journeys.prestay">Set up your variations for this conversion point</a>
                                    </div>

                                    <div class="ft-conversion-display" ft-state="guest-journeys.prestay" ft-state-class="{'active': 'guest-journeys.prestay'}">
                                        <div class="ft-nav ft-navbar ft-contexttabs-nav">
                                            <ul>
                                                <li class="active">
                                                    <a>Variations</a>
                                                </li>
                                                <!--<li class="active"><a>Active</a></li>
                                                <li><a>Inactive</a></li>-->
                                                <li class="ft-navitem-action">
                                                    <a (click)="newCampaign('pre-stay')" [ngClass]="{'disabled': prestayCampaignsSortMode}">
                                                        <i class="ft-icn-plus"></i>
                                                        New variation
                                                    </a>
                                                </li>
                                                <li class="ft-navitem-action">
                                                    <a class="ft-link-text-invert" (click)="prestayCampaignsSortMode ? saveSortOrder('pre-stay') : toggleSortMode('pre-stay')">
                                                        <i class="ft-icn-sort"></i>
                                                        Change order
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="ft-conversion-display-info">
                                            {{'flipto.account.YourGuestsAndTheirFriendsCanEarnIncentives' | translate}} {{'flipto.account.OnlyTheFirstVariationBelowThatFitsYourGuestsProfile' | translate}} {{'flipto.account.DisplayingStatsFor' | translate}}
                                            <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [darkMode]="true" [inlineMode]="true" />
                                        </div>

                                        <ft-campaign-list [campaigns]="prestayCampaigns?.campaigns?.item" [sortMode]="prestayCampaignsSortMode" (campaignSelected)="showCampaignDetails('pre-stay', $event.id)" />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-share-section">
                            <div class="ft-section-bg">
                                <div class="ft-map"></div>
                                <div class="ft-parallel-journey ft-persona-scheme-friends">
                                    <div class="ft-profile-path">
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                    <div class="ft-journey-path"></div>
                                </div>
                            </div>
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-container">
                                <div class="ft-content">
                                    <div class="ft-section-info">
                                        <h2 class="ft-heading ft-text-plus-2">New friend journey!</h2>
                                        <p>
                                            Any friend who clicks Jill's share link will begin their own journey to inspiration.
                                        </p>
                                        <a class="ft-text-block" ftSectionTrigger="inspiration1" ft-carousel-card-trigger="inspiration1" ft-scroll-to=".ft-main">
                                            Go to Friend's journey
                                            <i class="ft-icn-arrow-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificateemail-prestay-guest is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed
                                                        representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificateemail-info">
                                                <p>
                                                    The certificate email will provide a unique link to Jill's certificate, where she can get further instructions on next steps.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-certificatereminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jill doesn't redeem her certificate 30 days before it expires, we'll send a reminder email. (This email is only sent if
                                                    the expiration date is more than 60 days from when Jill originally earned
                                                    it.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !warmLeadNurturing?.isCertificateReminderEnabled}" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-reminder-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-certificatepage-guest">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jill can redeem her bonus through her certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in
                                                    <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-followupemail">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed
                                                        representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-followupemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    In the event that Jill doesn't share on the Confirmation Experience, we'll follow up with an email one hour later that includes
                                                    a link to her personal share page. She can share whenever she's ready.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !prestayAdvocacy?.isFollowupEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{prestayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'followup'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Followup Email + Share Page</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">

                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-bannerforconfirmation">
                                                <div class="ft-browserviewport"></div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-bannerforconfirmation-info">
                                                <p>
                                                    To make sure Jill is presented with every opportunity to share and earn her bonus, we provided a banner that you can insert
                                                    in your confirmation email. This banner links to Jill's personal share
                                                    page.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !prestayAdvocacy?.isConfirmationEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{prestayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'confirmation-email-image'}">
                                                    <i class="ft-icn-image"></i>
                                                    <span class="ft-touchpoint-name">Banner for Confirmation Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-bannerforprearrival">
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual banner will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-bannerforprearrival-info">
                                                <p>
                                                    As the arrival date approaches, you can include a banner in your pre-arrival email to drum up interest in a Storyteller Campaign
                                                    that Jill can join after her stay.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isPrearrivalEmailImageActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'pre-arrival-email', dataType: 'styling'}">
                                                    <i class="ft-icn-image"></i>
                                                    <span class="ft-touchpoint-name">Banner for Pre-arrival Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-waypoint icon-signage">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-icon-container">
                                            <div class="ft-icn-plane"></div>
                                        </div>
                                    </div>
                                    <div class="ft-row">
                                        <div class="ft-col-40 ft-col-left">
                                            <div class="ft-section-info ft-gueststay-info-1">
                                                <p>
                                                    Once Jill arrives at your hotel, it's your team's turn to show her what you got.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="ft-col-40 ft-col-right">
                                            <div class="ft-section-info ft-gueststay-info-2">
                                                <p>
                                                    Treat her to the best in hospitality and she'll return with fond memories from her stay, plus she'll have even more valuable
                                                    content to share.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-team-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image" [style.background-image]="'url(' + (property.BackgroundImageUrl) + ')'"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Team involvement</span>
                            </div>
                            <h2 class="ft-heading ft-text-plus-3">What your team will see.</h2>
                            <section class="ft-section last">
                                <div class="ft-content ft-perspective">
                                    <div class="ft-container">
                                        <div class="ft-row">
                                            <div class="ft-col-60 ft-col-right">
                                                <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-dailyguestarrivalnotification is-scrollable">
                                                    <div class="ft-browserchrome"></div>
                                                    <div class="ft-browserviewport"></div>
                                                    <div class="ft-icn-scrollable">
                                                        <span>Scroll image</span>
                                                    </div>
                                                    <div class="ft-section-image-caption">
                                                        <p>Sample screenshot. Actual email will display your incentive.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ft-col-40">
                                                <div class="ft-section-info ft-dailyguestarrivalnotification-info is-scrollable">
                                                    <p>
                                                        Each morning, we'll send an email notification to your reception desk providing the details for Jill and other guests arriving
                                                        that day.
                                                    </p>
                                                    <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-email"></i><span class="ft-touchpoint-name">Daily Guest Arrival Notification</span></div>-->
                                                </div>
                                                <div class="ft-section-info ft-futureguestarrivalnotification-info">
                                                    <p>
                                                        We can also send a list of guests one week ahead if you like to be prepared.
                                                    </p>
                                                    <p>
                                                        Go to
                                                        <span class="ft-text-block">Notifications</span> to edit your preferences.
                                                    </p>
                                                    <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-email"></i><span class="ft-touchpoint-name">Future Guest Arrival Notification</span></div>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPoststaySection();" ftSectionTrigger="poststay" ft-carousel-card-trigger="poststay" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-content">
                                                <p class="ft-supertitle">Next up...</p>
                                                <h2 class="ft-heading ft-text-plus-6">Post-stay</h2>
                                                <p class="ft-summary">Jill's journey continues after she checks out.</p>
                                                <a class="ft-journey-offramp-link">
                                                    Continue
                                                    <i class="ft-icn-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- POST-STAY ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="poststay" class="ft-persona-scheme-guests" [ngClass]="{'is-journey-off': !platformActivationStatus.poststay, 'is-journey-inactive': (!!poststayAdvocacy && !poststayAdvocacy?.isActive)}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.poststay || (!!poststayAdvocacy && !poststayAdvocacy?.isActive)">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert" *ngIf="!platformActivationStatus.poststay">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is OFF.</h3>
                                            <p>
                                                Explore the journey below to learn about what your guests will see.
                                                <br /> Contact your account manager to launch this feature.
                                            </p>
                                            <ft-switch *ngIf="isFliptoStaff" state="platformActivationStatus.poststay" on-change="toggleLayer('poststay')" />
                                        </div>
                                    </div>
                                    <div class="ft-alert" *ngIf="platformActivationStatus.poststay && !!poststayAdvocacy && !poststayAdvocacy?.isActive">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Your guests will not see this journey until you activate your Post-stay Process touchpoint below.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-poststayinvitationemail is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-poststayinvitationemail-info">
                                                <p>
                                                    Catch up with Jill to learn more about how her stay was and ask her to share a quote and photo of her favorite moment. We'll
                                                    send an email three days after checkout that directs Jill to the Post-stay
                                                    Process.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !poststayAdvocacy?.isEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{poststayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'invitation-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Post-stay Invitation Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-poststayreminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jill hasn't clicked through the email, we'll send a single, gentle reminder email after three days.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !poststayAdvocacy?.isReminderEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{poststayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'reminder-emails'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-bannerforpoststay">
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual banner will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-bannerforpoststay-info">
                                                <p>
                                                    If you prefer to stick to your own post-stay email, you can always include a link to the Post-stay Process in your template&mdash;we
                                                    made this banner just for that purpose.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isPoststayEmailImageActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'poststay-email-image'}">
                                                    <i class="ft-icn-image"></i>
                                                    <span class="ft-touchpoint-name">Banner for Post-stay Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-poststay">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-poststay-info">
                                                <p>
                                                    The Post-stay Process gives Jill the opportunity to tell her story about a favorite moment from her stay. You’ll have a chance to curate her content before it's used across your platform.
                                                </p>
                                                <p *ngIf="platformActivationStatus.photoAdvocacy">
                                                    Jill’s next path depends on your platform setup. If Jill joins your Storytellers Campaign, she’ll move right ahead to the Storytellers journey. If Jill doesn’t join, and you’ve set up a post-stay variation, she'll follow the rest of this journey.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !poststayAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{poststayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'quote'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Post-stay Process</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-poststayreengagementemail">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-poststayreengagementemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jill started the Post-stay Process but dropped at any point along the way, we'll send a single Re-engagement Email 3
                                                    days later to see if she wants to pick up where she left off.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !poststayAdvocacy?.isReengagementEmailActive || !photoAdvocacy?.isActive}"
                                                     ft-touchpoint-trigger="{campaignUuid: '{{poststayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'reengagement-emails'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Re-engagement Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section ft-variable-section start" *ngIf="platformActivationStatus.photoAdvocacy">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-variable-message">
                                        Jill will only see the following parts of this journey if she doesn't join your storytellers campaign during the Post-stay Process.
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-guest"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">Jill's advocating with her own story.</h2>
                                    <p class="ft-summary">
                                        When Jill shares her favorite moment, she’ll advocate your hotel to friends & family. This is an important moment&mdash;Jill has provided real content that is already working to spread the good word about your hotel.
                                    </p>
                                    <p></p>

                                    <div class="ft-conversion-display" *ngIf="!!poststayShareIncentive" ft-state-class="{'active': 'guest-journeys.poststay'}" inverse>
                                        <div class="ft-participant-incentive">
                                            <div class="ft-supertitle-divider">
                                                <div class="ft-supertitle">
                                                    <i class="ft-icn-sun"></i>Thank Jill for sharing
                                                </div>
                                            </div>
                                            <div class="ft-incentive-name ft-text-plus-2">{{poststayShareIncentive.name}}</div>
                                        </div>
                                        <a class="ft-link-underline ft-text-minus-1" ft-set-state="guest-journeys.poststay">View your variation for this conversion point</a>
                                    </div>
                                    <div class="ft-conversion-display" *ngIf="!poststayShareIncentive" ft-state-class="{'active': 'guest-journeys.poststay'}" inverse>
                                        <a class="ft-link-underline ft-text-minus-1" ft-set-state="guest-journeys.poststay">Set up a variation for this conversion point</a>
                                    </div>

                                    <div class="ft-conversion-display" ft-state="guest-journeys.poststay" ft-state-class="{'active': 'guest-journeys.poststay'}">
                                        <div class="ft-nav ft-navbar ft-contexttabs-nav">
                                            <ul>
                                                <li class="active">
                                                    <a>Variations</a>
                                                </li>
                                                <!--<li class="active"><a>Active</a></li>
                                                <li><a>Inactive</a></li>-->
                                                <!--<li class="ft-navitem-action"><a><i class="ft-icn-plus"></i>New variation</a></li>-->
                                            </ul>
                                        </div>
                                        <div class="ft-conversion-display-info">
                                            {{'flipto.account.YourGuestsAndTheirFriendsCanEarnIncentives' | translate}}
                                            <br />
                                            {{'flipto.account.DisplayingStatsFor' | translate}}
                                            <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [darkMode]="true" [inlineMode]="true" />
                                            <!--<a class="ft-link-underline">Change order</a>-->
                                        </div>
                                        <ft-campaign-list [campaigns]="poststayCampaigns?.campaigns?.item" [sortMode]="poststayCampaignsSortMode" (campaignSelected)="showCampaignDetails('post-stay', $event.id)" />
                                    </div>

                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-share-section">
                            <div class="ft-section-bg">
                                <div class="ft-map"></div>
                                <div class="ft-parallel-journey ft-persona-scheme-friends">
                                    <div class="ft-profile-path">
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                    <div class="ft-journey-path"></div>
                                </div>
                            </div>
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-container">
                                <div class="ft-content">
                                    <div class="ft-section-info">
                                        <h2 class="ft-heading ft-text-plus-2">New friend journey!</h2>
                                        <p>
                                            Any friend who clicks Jill's share link will begin their own journey to inspiration.
                                        </p>
                                        <a class="ft-text-block" ftSectionTrigger="inspiration1" ft-carousel-card-trigger="inspiration1" ft-scroll-to=".ft-main">
                                            Go to Friend's journey
                                            <i class="ft-icn-arrow-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificateemail-poststay-guest is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed
                                                        representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificateemail-info">
                                                <p>
                                                    The certificate email provides a unique link to Jill's certificate, where she can get further instructions on next steps.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-certificatereminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jill doesn't redeem her certificate 30 days before it expires, we'll send a reminder email. (This email is only sent if
                                                    the expiration date is more than 60 days from when Jill originally earned
                                                    it.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-reminder-email'}" [ngClass]="{'disabled': !warmLeadNurturing?.isCertificateReminderEnabled}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-certificatepage-guest">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jill's can redeem her bonus through her certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section ft-variable-section end" *ngIf="platformActivationStatus.photoAdvocacy">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-variable-message">
                                        Jill will only see the preceding parts of this journey if she doesn't join your storytellers campaign during the Post-stay Process.
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-waypoint icon-signage">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-icon-container">
                                            <div class="ft-icn-flag"></div>
                                        </div>
                                    </div>
                                    <div class="ft-row">
                                        <div class="ft-col-40 ft-col-left">
                                            <div class="ft-section-info ft-poststaycomplete-info-1">
                                                <p>
                                                    When Jill completes the Post-stay Process, her story, along with all of your other guests' stories, becomes part of the larger story of your brand.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="ft-col-40 ft-col-right">
                                            <div class="ft-section-info ft-poststaycomplete-info-2">
                                                <p>
                                                    Although the content they've submitted is great, it's your relationship with every guest who shared their story that's invaluable. All areas of your platform focuses on maximizing on this to get the most benefit.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-team-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image" [style.background-image]="'url(' + (property.BackgroundImageUrl) + ')'"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Team involvement</span>
                            </div>
                            <h2 class="ft-heading ft-text-plus-3">
                                Invaluable content and feedback.
                            </h2>
                            <section class="ft-section">
                                <div class="ft-content ft-perspective">
                                    <div class="ft-container">
                                        <div class="ft-row">
                                            <div class="ft-col-60 ft-col-right">
                                                <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-dailystoriesnotification is-scrollable">
                                                    <div class="ft-browserchrome"></div>
                                                    <div class="ft-browserviewport"></div>
                                                    <div class="ft-icn-scrollable">
                                                        <span>Scroll image</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ft-col-40">
                                                <div class="ft-section-info ft-dailystoriesnotification-info">
                                                    <p>
                                                        Curate the quote, photo and caption that Jill submitted in a few easy clicks. Content will never appear before audiences unless you approve them, giving you complete control of the collective story you are telling about your brand.
                                                    </p>
                                                    <p>
                                                        We'll send an update when you receive new content from your guests. You'll be prompted to curate them so they can be used to inspire new travelers to your hotel.
                                                    </p>
                                                    <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-email"></i><span class="ft-touchpoint-name">Stories notification</span></div>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section class="ft-section last">
                                <div class="ft-content ft-perspective">
                                    <div class="ft-container">
                                        <div class="ft-row">
                                            <div class="ft-col-60">
                                                <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-dailyfeedbacknotification is-scrollable">
                                                    <div class="ft-browserchrome"></div>
                                                    <div class="ft-browserviewport"></div>
                                                    <div class="ft-icn-scrollable">
                                                        <span>Scroll image</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ft-col-40">
                                                <div class="ft-section-info ft-dailyfeedbacknotification-info">
                                                    <p>
                                                        We'll send the latest feedback so you can monitor guest sentiment and see what they thought could have improved their stay.
                                                    </p>
                                                    <p>
                                                        Although the post-stay journey collects great stories from your guests, it was also designed to give unhappy guests an attentive ear so they could offer constructive criticism or unleash a tirade. It's better to catch disgruntled guests early and have them voice their opinions to you so you can respond appropriately.
                                                    </p>
                                                    <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-email"></i><span class="ft-touchpoint-name">Feedback notification</span></div>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPhotoContestSection();" ftSectionTrigger="photocontest" ft-carousel-card-trigger="photocontest" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-content">
                                                <p class="ft-supertitle">Next up...</p>
                                                <h2 class="ft-heading ft-text-plus-6">Storytellers</h2>
                                                <p class="ft-summary">Jill becomes a co-creator and powerful influencer.</p>
                                                <a class="ft-journey-offramp-link">
                                                    Continue <i class="ft-icn-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- STORYTELLERS ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="photocontest" class="ft-persona-scheme-guests" [ngClass]="{'is-journey-off': !platformActivationStatus.photoAdvocacy, 'is-journey-inactive': (!!photoAdvocacy && !photoAdvocacy?.isActive)}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.photoAdvocacy || (!!photoAdvocacy && !photoAdvocacy?.isActive)">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert" *ngIf="!platformActivationStatus.photoAdvocacy">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is OFF.</h3>
                                            <p>
                                                Explore the journey below to learn about what your guests will see.
                                                <br />
                                                Contact your account manager to launch this feature.
                                            </p>
                                            <ft-switch *ngIf="isFliptoStaff" state="platformActivationStatus.photoAdvocacy" on-change="toggleLayer('photocontest')" />
                                        </div>
                                    </div>
                                    <div class="ft-alert" *ngIf="platformActivationStatus.photoAdvocacy && !!photoAdvocacy && !photoAdvocacy?.isActive">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Your guests will not see this journey until you activate your Story Explorer touchpoint below.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-contestfinalistemail is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-contestfinalistemail-info">
                                                <p>
                                                    Once you approve Jill's submission, she'll receive an email with a link to her personal storyteller page.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isFinalistEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'finalistsEmail'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Finalist Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-contestreminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If she doesn't click that email, we'll follow up with a reminder email three days later.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isReminderEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'reminderEmail'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--<div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-contestreminderemail"><div class="ft-browserchrome"></div></div>
                                        </div>
                                        <div class="ft-col-40">
                                        </div>
                                    </div>-->
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-storycontest is-scrollable is-option-rank">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-storyexplorer-info">
                                                <p>
                                                    Jill's first visit to her storyteller page automatically places her vote, putting her on the scoreboard. From there she can share to friends &amp; family to rally votes.
                                                </p>
                                                <p>
                                                    Each time Jill shares she earns points, and reinforces your brand to her friends & family. Friends show support through votes, adding a few more points to Jill's score.
                                                </p>
                                                <p>
                                                    For the ultimate score boost, friends can reach into their own social circles to rally for votes. This increases your reach tremendously.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'contestPage', dataType: 'styling'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Story Explorer</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-guest"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-guest"></div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">Jill's story powers the conversion machine.</h2>
                                    <p class="ft-summary">
                                        When Jill shares to her friends, she'll advocate your hotel with a personal story about her experience. This is an important moment&mdash;Jill has provided real content that is already working to spread the good word about your hotel.
                                    </p>
                                    <p class="ft-summary">
                                        The prizes that Jill and fellow storytellers can win are set per campaign. You can see your campaign or create a new one in <a class="ft-link-underline" ui-state="'advocacy.contests'">Campaigns</a>.
                                    </p>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-contestactivityemail is-scrollable is-option-rank">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-contestactivityemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    The activity email is sent to Jill every seven days for the duration of the campaign with updates on how her progress is going. (This email is only sent to active storytellers.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isActivityEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'activityEmail'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Activity Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-waypoint icon-signage">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-icon-container">
                                            <div class="ft-icn-trophy"></div>
                                        </div>
                                    </div>
                                    <div class="ft-row">
                                        <div class="ft-col-40 ft-col-right">
                                            <div class="ft-section-info ft-contestend-info">
                                                <p>
                                                    When the storyteller campaign ends, it's time to choose the winners. You'll be able to do this over in <a class="ft-link-underline" ui-state="'advocacy.contests'">Campaigns</a>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-contestwinneremail is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-contestwinneremail-info">
                                                <p>
                                                    If you select Jill as a winner, she'll receive an email with a link to her prize certificate.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isWinnerEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'winnerEmail'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Winner Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificatepage-guest">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jill can redeem her bonus through her certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" ftSectionTrigger="inspiration2" ft-carousel-card-trigger="inspiration2" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted.</h2>
                                                <p>
                                                    As Jill's journey comes to a close, we'll wait until she's ready to travel again so we can kick off a new journey with her.
                                                </p>
                                                <p>
                                                    In the meantime, Jill made warm introductions for your hotel to her friends &amp; family. We'll nurture those relationships so your hotel is top-of-mind when they are ready to travel.
                                                </p>
                                                <a class="ft-journey-offramp-link">
                                                    View their journey <i class="ft-icn-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- BUILD AWARENESS ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="inspiration1" class="ft-persona-scheme-friends" [ngClass]="{'is-journey-off': (!platformActivationStatus.prestay && !platformActivationStatus.poststay), 'is-journey-inactive': (!prestayAdvocacy?.isActive && !poststayAdvocacy?.isActive)}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="(!platformActivationStatus.prestay && !platformActivationStatus.poststay) || (!prestayAdvocacy?.isActive && !poststayAdvocacy?.isActive)">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Friends will not see this journey until you activate your guest's <a href="#" (click)="fetchPrestaySection();" ftSectionTrigger="prestay" ft-carousel-card-trigger="prestay" ft-scroll-to=".ft-main">Pre-stay</a> or <a href="#" ftSectionTrigger="poststay" ft-carousel-card-trigger="poststay" ft-scroll-to=".ft-main">Post-stay</a> journey.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-friendlanding">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-friendlanding-info">
                                                <p>
                                                    From a simple link that Jill shared in her Pre-stay or Post-stay journey, Jack begins his journey with your hotel. He'll immediately see Jill's excitement about her trip to your hotel and he can also save a bonus for a future stay of his own.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{campaignUuid: '{{prestayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'landing'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Friend Landing Experience</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-friendlandingmobile-info">
                                                <p>
                                                    If you use the integrated or custom mode for your Friend Landing Experience, we'll show a different version made specifically for mobile devices.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{campaignUuid: '{{prestayCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'mobile'}"
                                                     [ngClass]="{'disabled': !prestayAdvocacy?.isMobileActive}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Friend Landing (mobile)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-friend"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">Jack's a warm lead!</h2>
                                    <p class="ft-summary">
                                        When Jack signs up to receive a bonus, he's showing genuine interest in considering your hotel for future travel. This is an important moment&mdash;we can now start meaningful conversations with Jack.
                                    </p>
                                    <div class="ft-participant-incentive">
                                        <div class="ft-supertitle-divider">
                                            <div class="ft-supertitle">
                                                <i class="ft-icn-sun"></i>Send Jack a bonus
                                            </div>
                                        </div>
                                        <div class="ft-incentive-name ft-text-plus-2" *ngIf="!!prestaySignupIncentive">{{prestaySignupIncentive.name}}</div>
                                        <div class="ft-incentive-name ft-text-plus-2" *ngIf="!prestaySignupIncentive">No incentive has been set</div>
                                    </div>
                                    <p class="ft-summary ft-text-minus-1">
                                        The incentive a friend receives is based on the guest who shared. Go to your guest's
                                        <a class="ft-link-underline" (click)="fetchPrestaySection();" ft-carousel-card-trigger="prestay" ftSectionTrigger="prestay" ft-scroll-to=".ft-main">
                                            Pre-stay
                                        </a>
                                        or
                                        <a class="ft-link-underline" (click)="fetchPoststaySection();" ft-carousel-card-trigger="poststay" ftSectionTrigger="poststay" ft-scroll-to=".ft-main">
                                            Post-stay
                                        </a>
                                        conversion point to edit them.
                                    </p>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-certificateemail-prestay-friend is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificateemail-info">
                                                <p>
                                                    The certificate email provides a unique link to Jack's certificate, where he can get further instructions on next steps.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-certificatereminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jack doesn't redeem his certificate 30 days before it expires, we'll send a reminder email. (This email is only sent if the expiration date is more than 60 days from when Jack originally earned it.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-reminder-email'}" [ngClass]="{'disabled': !warmLeadNurturing?.isCertificateReminderEnabled}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificatepage-friend">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jack can redeem his bonus through his certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPrestaySection();" ftSectionTrigger="prestay" ft-carousel-card-trigger="prestay" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted, and good things come to those who wait...</h2>
                                                <p>
                                                    If Jack decides on your hotel for a future stay, he'll begin a new Pre-stay Journey as a guest and will be nurtured to advocate your hotel to his circle of friends &amp; family.
                                                </p>
                                            </div>
                                            <a class="ft-journey-offramp-link">
                                                Explore Pre-stay Journey <i class="ft-icn-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- INSPIRATION ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="inspiration2" class="ft-persona-scheme-friends" [ngClass]="{'is-journey-off': !platformActivationStatus.photoAdvocacy, 'is-journey-inactive': (!!photoAdvocacy && !photoAdvocacy?.isActive)}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.photoAdvocacy || (!!photoAdvocacy && !photoAdvocacy?.isActive)">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Friends will not see this journey until you activate your guest's <a (click)="fetchPhotoContestSection();" ftSectionTrigger="photocontest" ft-carousel-card-trigger="photocontest" ft-scroll-to=".ft-main">Storytellers</a> journey.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-storycontestfriendsplash is-option-rank">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-storycontestfriendsplash-info">
                                                <p>
                                                    When Jack clicks through Jill's storyteller link, he'll see her status and a roster of friends who have already voted for her story. Jack can cast his vote to show support, and he can also opt to receive a bonus for a future stay if he's interested.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'contestPage', dataType: 'styling'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Story Explorer</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-friend"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-friend"></div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">Jack's a warm lead!</h2>
                                    <p class="ft-summary">
                                        When Jack signs up to receive a certificate, he's showing genuine interest in considering your hotel for future travel. This is an important moment&mdash;we can now start meaningful conversations with Jack.
                                    </p>
                                    <p class="ft-summary">
                                        The incentive that Jack and other friends can earn are set per campaign. You can see your campaign or create a new one in <a class="ft-link-underline" ui-state="'advocacy.contests'">Campaigns</a>.
                                    </p>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-certificateemail-photo-contest-vote-friend is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificateemail-info">
                                                <p>
                                                    The certificate email provides a unique link to Jack's certificate, where he can get further instructions on next steps.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-certificatereminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jack doesn't redeem his certificate 30 days before it expires, we'll send a reminder email. (This email is only sent if the expiration date is more than 60 days from when Jack originally earned it.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-reminder-email'}" [ngClass]="{'disabled': !warmLeadNurturing?.isCertificateReminderEnabled}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificatepage-friend">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jack can redeem his bonus through his certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPrestaySection();" ftSectionTrigger="prestay" ft-carousel-card-trigger="prestay" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted, and good things come to those who wait...</h2>
                                                <p>
                                                    If Jack decides on your hotel for a future stay, he'll begin a new Pre-stay Journey as a guest and will be nurtured to advocate your hotel to his circle of friends &amp; family.
                                                </p>
                                            </div>
                                            <a class="ft-journey-offramp-link">
                                                Explore Pre-stay Journey <i class="ft-icn-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-appendix-section">
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-content">
                                        <p class="ft-supertitle">But what happens if...</p>
                                        <h2 class="ft-heading ft-text-plus-2">Jack never uses his bonus, or never opted to receive a bonus in the first place?</h2>
                                        <div class="ft-summary">
                                            <p>
                                                That's OK, we'll wait for a better opportunity to convert. There's no need to engage people who are not ready to take action&mdash;timing is key to a quality conversion, and with colder leads this is critical to remember.
                                            </p>
                                            <p>
                                                Stay tuned for new features we've got on our roadmap that will introduce conversations to strike up with people who are not ready to travel.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- SUPERCHARGERS1 - STORY RIVER ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="superchargers1" class="ft-persona-scheme-visitors" [ngClass]="{'is-journey-off': !platformActivationStatus.photoAdvocacy, 'is-journey-inactive': (!!photoAdvocacy && (!photoAdvocacy?.isActive || !photoAdvocacy?.isPhotoRiverActive))}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.photoAdvocacy || (!!photoAdvocacy && (!photoAdvocacy?.isActive || !photoAdvocacy?.isPhotoRiverActive))">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is not active.</h3>
                                            <p>
                                                Website visitors will not see this journey until you activate your guest's <a (click)="fetchPhotoContestSection();" ftSectionTrigger="photocontest" ft-carousel-card-trigger="photocontest" ft-scroll-to=".ft-main">Storytellers</a> journey.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-storyriver">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-storyriver-info">
                                                <p>
                                                    A steady flow of current, authentic stories shows website visitors the real side of your hotel. Because there's a story for everyone, it's the best way to get visitors to imagine themselves at your hotel.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'photo-river'}"
                                                     [ngClass]="{'disabled': !photoAdvocacy?.isPhotoRiverActive}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Story River</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-storygallery is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-storyexplorer2-info">
                                                <p>
                                                    Visitors who click through the Story River can explore an entire gallery of guest stories. The Story Explorer provides a great look at your guest experience with colorful stories and captivating visuals, and gives visitors a way to earn a bonus for an upcoming stay.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !photoAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{photoAdvocacyCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'contestPage', dataType: 'styling'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Story Explorer</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-anonymous-1"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-anonymous-1">
                                            <div class="ft-profile-initials">Jenny</div>
                                        </div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">You unveiled a warm lead!</h2>
                                    <p class="ft-summary">
                                        When X3Mqq7 signs up to receive a bonus, she's showing genuine interest in considering your hotel for future travel. This is an important moment&mdash;we can now start meaningful conversations with Jenny.
                                    </p>

                                    <div class="ft-conversion-display" *ngIf="!!photoAdvocacySignupIncentive" ft-state-class="{'active': 'guest-journeys.photoAdvocacy'}" inverse>
                                        <div class="ft-participant-incentive">
                                            <div class="ft-supertitle-divider">
                                                <div class="ft-supertitle">
                                                    <i class="ft-icn-sun"></i>Send Jenny a bonus
                                                </div>
                                            </div>
                                            <div class="ft-incentive-name ft-text-plus-2" [innerHTML]="photoAdvocacySignupIncentive.name"></div>
                                        </div>
                                        <a class="ft-link-underline ft-text-minus-1" ft-set-state="guest-journeys.photoAdvocacy">View all variations for this conversion point</a>
                                    </div>
                                    <div class="ft-conversion-display" *ngIf="!photoAdvocacySignupIncentive" ft-state-class="{'active': 'guest-journeys.photoAdvocacy'}" inverse>
                                        <a class="ft-link-underline ft-text-minus-1" ft-set-state="guest-journeys.photoAdvocacy">Set up your variations for this conversion point</a>
                                    </div>

                                    <div class="ft-conversion-display" ft-state="guest-journeys.photoAdvocacy" ft-state-class="{'active': 'guest-journeys.photoAdvocacy'}">
                                        <div class="ft-nav ft-navbar ft-contexttabs-nav">
                                            <ul>
                                                <li class="active">
                                                    <a>Variations</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="ft-conversion-display-info">
                                            {{'flipto.account.YourWebsiteVisitorsCanEarnIncentives' | translate}}
                                            <br />
                                            {{'flipto.account.DisplayingStatsFor' | translate}}
                                            <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [darkMode]="true" [inlineMode]="true" />
                                        </div>

                                        <ft-campaign-list [campaigns]="photoCampaigns?.campaigns?.item" layerType="6" [sortMode]="photoAdvocacyCampaignsSortMode"
                                                          (campaignSelected)="showCampaignDetails('photo-advocacy', $event.id)" />
                                    </div>

                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-certificateemail-story-river-anon is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>
                                                        Sample screenshot. Actual email will display your incentive and appointed representative.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificateemail-info">
                                                <p>
                                                    The certificate email provides a unique link to Jenny's certificate, where she can get further instructions on next steps.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-email'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Email</span>
                                                </div>
                                            </div>
                                            <div class="ft-section-info ft-certificatereminderemail-info">
                                                <p>
                                                    <!-- Schedule info -->
                                                    If Jenny doesn't redeem her certificate 30 days before it expires, we'll send a reminder email. (This email is only sent if the expiration date is more than 60 days from when Jenny originally earned it.)
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" ft-touchpoint-trigger="{propertyUuid: '{{property.UUID}}', name: 'certificate-reminder-email'}" [ngClass]="{'disabled': !warmLeadNurturing?.isCertificateReminderEnabled}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Certificate Reminder Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-certificatepage-anon">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport">
                                                    <div class="ft-browserviewport-logo" [style.background-image]="'url(' + (property.logoUrl) + ')'"></div>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot. Actual page will display your incentive.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-certificatepage-info">
                                                <p>
                                                    Jenny can redeem her bonus through her certificate page.
                                                </p>
                                                <p>
                                                    You can edit the content of this page in <span class="ft-text-block">Incentives</span>.
                                                </p>
                                                <!--<div class="ft-panel ft-touchpoint-panel"><i class="ft-icn-webpage"></i><span class="ft-touchpoint-name">Certificate Page</span></div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPrestaySection();" ftSectionTrigger="prestay" ft-carousel-card-trigger="prestay" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted, and good things come to those who wait...</h2>
                                                <p>
                                                    If Jenny decides on your hotel for a future stay, she'll begin a new Pre-stay Journey as a guest and will be nurtured to advocate your hotel to her circle of friends &amp; family.
                                                </p>
                                            </div>
                                            <a class="ft-journey-offramp-link">
                                                Explore Pre-stay Journey <i class="ft-icn-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-appendix-section">
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-content">
                                        <p class="ft-supertitle">But what happens if...</p>
                                        <h2 class="ft-heading ft-text-plus-2">Jenny never uses her bonus, or never opted to receive a bonus in the first place?</h2>
                                        <div class="ft-summary">
                                            <p>
                                                That's OK, we'll wait for a better opportunity to convert. There's no need to engage people who are not ready to take action&mdash;timing is key to a quality conversion, and with colder leads this is critical to remember.
                                            </p>
                                            <p>
                                                Stay tuned for new features we've got on our roadmap that will introduce conversations to strike up with people who are not ready to travel.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                    <!-- SUPERCHARGERS2 - HPC ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="superchargers2" class="ft-persona-scheme-visitors" [ngClass]="{'is-journey-off': !platformActivationStatus.homepage}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.homepage">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert" *ngIf="!platformActivationStatus.homepage">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is OFF.</h3>
                                            <p>
                                                Explore the journey below to learn about what your visitors will see.
                                                <br />
                                                Contact your account manager to launch this feature.
                                            </p>
                                            <ft-switch *ngIf="isFliptoStaff" state="platformActivationStatus.homepage" on-change="toggleLayer('homepage')" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-hpc">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-hpc-info">
                                                <p>
                                                    Most website visitors come to your site to research their options, and only a fraction are ready to book. For the majority, the Homepage Component provides an opportunity to unlock a bonus when they are ready, giving your visitor a compelling reason to come back and book direct.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !homepageAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{homepageCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'homepage'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Homepage Component</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section ft-conversion-section ft-waypoint-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-section-bg">
                                <!--<div class="ft-bg-image ft-profile-anonymous-2"></div>
                                <div class="ft-bg-matte"></div>-->
                            </div>
                            <div class="ft-journey-waypoint text-signage" ft-positional-class="filled" ft-positional-class-on="75%">
                                <div class="ft-journey-path-fill"></div>
                                <span>Conversion point</span>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-profile-path">
                                        <div class="ft-journey-path-fill"></div>
                                        <div class="ft-profile-pic ft-profile-anonymous-2">
                                            <div class="ft-profile-initials">Alex</div>
                                        </div>
                                    </div>
                                    <h2 class="ft-heading ft-text-plus-3">You unveiled a potential future advocate!</h2>
                                    <p class="ft-summary">
                                        When Y4NtpU unlocks his bonus, he's showing genuine interest in considering your hotel for future travel. This is an important moment&mdash;we can now start meaningful conversations with Alex.
                                    </p>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60 ft-col-right">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-hpcredeememail">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-hpcredeememail-info">
                                                <p>
                                                    When Alex is ready to book, he can use the unique link in his Redeem Email to make his reservation. Immediately following his booking confirmation, Alex will have a chance to earn his bonus by spreading the word of his trip, along with a special incentive, to friends &amp; family.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !homepageAdvocacy?.isEmailActive}" ft-touchpoint-trigger="{campaignUuid: '{{homepageCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'homepageEmail'}">
                                                    <i class="ft-icn-email"></i>
                                                    <span class="ft-touchpoint-name">Redeem Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp" (click)="fetchPrestaySection();" ftSectionTrigger="prestay" ft-carousel-card-trigger="prestay" ft-scroll-to=".ft-main" ft-scroll-behavior="instant">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted, and good things come to those who wait...</h2>
                                                <p>
                                                    If Alex decides on your hotel for a future stay, he'll begin a new Pre-stay Journey as a guest and will be nurtured to advocate your hotel to his circle of friends &amp; family.
                                                </p>
                                            </div>
                                            <a class="ft-journey-offramp-link">
                                                Explore Pre-stay Journey <i class="ft-icn-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </ft-section>

                    <!-- SUPERCHARGERS3 - Quotes List ---------------------------------------------------------------------------------------------------- -->
                    <ft-section name="superchargers3" class="ft-persona-scheme-visitors" [ngClass]="{'is-journey-off': !platformActivationStatus.quoteList}">

                        <section class="ft-alert-section journey-status-alert" *ngIf="!platformActivationStatus.quoteList">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-alert" *ngIf="!platformActivationStatus.quoteList">
                                        <div class="ft-alert-content">
                                            <h3 class="ft-heading">This feature is OFF.</h3>
                                            <p>
                                                Explore the journey below to learn about what your visitors will see.
                                                <br />
                                                Contact your account manager to launch this feature.
                                            </p>
                                            <ft-switch *ngIf="isFliptoStaff" state="platformActivationStatus.quoteList" on-change="toggleLayer('quotelist')" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="ft-section first">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content ft-perspective">
                                <div class="ft-container">
                                    <div class="ft-row">
                                        <div class="ft-col-60">
                                            <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-quoteslist is-scrollable">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-icn-scrollable">
                                                    <span>Scroll image</span>
                                                </div>
                                                <div class="ft-section-image-caption">
                                                    <p>Sample screenshot.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-col-40">
                                            <div class="ft-section-info ft-quoteslist-info">
                                                <p>
                                                    The Quotes List shows personal and insightful stories from your guests, with a focus on recounting the favorite part of their stay. Only high rated quotes that you curated appear on the list so there are no surprises.
                                                </p>
                                                <div class="ft-panel ft-touchpoint-panel" [ngClass]="{'disabled': !quoteListAdvocacy?.isActive}" ft-touchpoint-trigger="{campaignUuid: '{{quoteListCampaignUuid}}', propertyUuid: '{{property.UUID}}', name: 'list', dataType: 'styling'}">
                                                    <i class="ft-icn-webpage"></i>
                                                    <span class="ft-touchpoint-name">Quotes List</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="ft-section last">
                            <div class="ft-journey-path">
                                <div class="ft-journey-path-fill"></div>
                            </div>
                            <div class="ft-content">
                                <div class="ft-container">
                                    <div class="ft-journey-offramp-path" ft-positional-class="filled" ft-positional-class-on="75%">
                                        <div class="ft-journey-waypoint icon-signage">
                                            <div class="ft-journey-path-fill"></div>
                                            <div class="ft-icon-container">
                                                <div class="ft-icn-seedplant"></div>
                                            </div>
                                        </div>
                                        <div class="ft-journey-path-fill ft-journey-path-end"></div>
                                        <div class="ft-journey-offramp">
                                            <div class="ft-summary">
                                                <h2 class="ft-heading ft-text-plus-2">The seed is planted, and good things come to those who wait...</h2>
                                                <p>
                                                    As Z5OIW9 continues to browse your website to decide on her travel plans, she'll have a more favorable view of your hotel as a viable option.
                                                    <a class="ft-link-underline" ftSectionTrigger="superchargers1" ft-carousel-card-trigger="superchargers1" ft-scroll-to=".ft-main">Story River</a>
                                                    and
                                                    <a class="ft-link-underline" ftSectionTrigger="superchargers2" (click)="fetchHomepageSection();" ft-carousel-card-trigger="superchargers2" ft-scroll-to=".ft-main">HPC</a>
                                                    can help convert her into a lead during this decision making stage.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ft-section>

                </div>
            </section>
        </ft-carousel-cards>
    </ft-sections>
</ft-initialized-content>
